import {
    el, mount, unmount, setStyle
} from 'redom';
import tooltip from 'tooltip';

import { getDevice, svgStringToDom } from '../../Utils/html';
import { NAKER_ICON } from './icons';

const prevent = (evt) => {
    evt.preventDefault();
    evt.stopPropagation();
};

const addStyle = (element: HTMLElement, styles) => {
    const keys = Object.keys(styles);
    keys.forEach((key) => {
        const style = styles[key];
        element.style.setProperty(key, style);
    });
};

export class UiWaterMark {
    protected parent: HTMLElement;

    private container: HTMLElement;

    private height = 35;

    private isOnMobile = false;

    private containerStyle = {
        height: `${this.height}px`,
        width: '200px',
        bottom: '5px',
        right: '5px',
        position: 'absolute',
        opacity: '0',
        'z-index': 1000,
        transition: 'all ease 200ms',
    };

    constructor(parent: HTMLElement) {
        this.parent = parent;
        this.container = el('div.naker-button-list', { style: this.containerStyle });
        this.setEvents();
        this.show();

        const TooltipCconfig = {
            // target: parent,
            // showDelay: 100,
            className: 'naker-button-tooltip',
            offset: { x: -this.height, y: 5 },
            style: {
                padding: 5,
                fontFamily: 'Verdana, sans-serif',
                fontSize: '14px',
                color: 'white',
                background: 'grey',
                borderRadius: '5px'
            }
        };
        tooltip(TooltipCconfig);
    }

    private setEvents() {
        const device = getDevice();
        // If on mobile we keep the menu always open
        // As it can be annoying to show it and click on it
        if (device === 'iOS' || device === 'Androïd') {
            this.isOnMobile = true;
            setStyle(this.container, { opacity: 1 });
        }
        this.parent.addEventListener('mousemove', () => {
            this.fadeIn();
        });

        // Show menu on mobile only if user tapped
        let moved = false;
        this.parent.addEventListener('touchmove', (evt) => {
            moved = true;
        });

        let lasttap = new Date().getTime();
        this.parent.addEventListener('touchend', (evt) => {
            const newtap = new Date().getTime();
            const time = newtap - lasttap;
            if (!moved) {
                if (this.visible && time > 500) this.fadeOut();
                else this.fadeIn();
            }
            lasttap = newtap;
            moved = false;
        });
    }

    public show(): void {
        mount(this.parent, this.container);
    }

    public hide(): void {
        unmount(this.parent, this.container);
    }

    private fadeTimeout;

    private visible = false;

    // Do not use system animation here because it will reset the quality of the scene
    public fadeIn(): void {
        if (this.isOnMobile) return;
        this.visible = true;
        setStyle(this.container, { opacity: 1 });

        if (this.fadeTimeout) clearTimeout(this.fadeTimeout);
        this.fadeTimeout = setTimeout(() => {
            if (!this.iconIsHovered) this.fadeOut();
        }, 5000);
    }

    public fadeOut(): void {
        if (this.isOnMobile) return;
        this.visible = false;
        setStyle(this.container, { opacity: 0 });
    }

    private buttonStyle = {
        position: 'relative',
        display: 'inline-block',
        float: 'right',
        padding: '5px',
        opacity: 0.6,
        background: 'grey',
        cursor: 'pointer',
        // - 10 because of the padding
        height: `${this.height - 10}px`,
        width: `${this.height - 10}px`,
        'box-sizing': 'unset',
        'webkit-box-sizing': 'unset',
        'border-radius': '5px',
        'margin-right': '5px',
        transition: 'all ease 200ms',
    };

    protected addButton(icon: string, tooltip: string, clickCallback: () => void): HTMLElement {
        const button = el('div.naker-button', {
            style: this.buttonStyle,
            'data-tooltip': tooltip,
            //! onclick not working with mouse so we use pointerup instead
            // onclick: () => { if (clickCallback) clickCallback(); },
            onmouseenter: () => { this.iconHovered(button); },
            onmouseleave: () => { this.iconNotHovered(button); }
        });
        button.addEventListener('pointerup', (e) => {
            prevent(e);
            if (clickCallback) clickCallback();
        });
        svgStringToDom(button, icon);
        addStyle(button, this.buttonStyle);
        mount(this.container, button);
        return button;
    }

    iconIsHovered = false

    private iconHovered(icon: HTMLElement) {
        this.iconIsHovered = true;
        setStyle(icon, { opacity: 1 });
    }

    private iconNotHovered(icon: HTMLElement) {
        this.iconIsHovered = false;
        setStyle(icon, { opacity: 0.8 });
    }

    waterMarkButton: HTMLElement;

    protected addWaterMark(): void {
        this.waterMarkButton = this.addButton(NAKER_ICON, null, () => {
            window.open('https://naker.io?href=watermark', '_blank');
        });
        setStyle(this.waterMarkButton, { 'margin-left': '10px' });
    }

    protected hideWaterMark(): void {
        if (this.waterMarkButton) setStyle(this.waterMarkButton, { display: 'none' });
    }

    protected showWaterMark(): void {
        if (this.waterMarkButton) setStyle(this.waterMarkButton, { display: 'block' });
    }
}
